const DISTRIBUTION = [
  {
    id: "t1",
    town: "Bulverde",
    zip: 78163,
    homes: "9,000",
  },
  {
    id: "t2",
    town: "Canyon Lake",
    zip: 78133,
    homes: "11,500",
  },
  {
    id: "t3",
    town: "Garden Ridge",
    zip: 78266,
    homes: "3,500",
  },
  {
    id: "t4",
    town: "New Braunfels",
    zip: 78130,
    homes: "47,000",
  },
  {
    id: "t5",
    town: "New Braunfels",
    zip: 78132,
    homes: "19,500",
  },
  {
    id: "t6",
    town: "Spring Branch",
    zip: 78070,
    homes: "9,500",
  },
];

export default DISTRIBUTION;
